<template>
  <tr class="border-b-2 border-gray-200 hover:bg-purple-500">
    <td class="p-2 text-sm text-gray-500">{{details.order_no}}</td>
    <td class="p-2 text-sm text-gray-500">{{details.customer}}</td>
    <td class="p-6" :class="status(details.status)">{{details.status}}</td>
<!--    <td class="p-2 text-sm text-gray-500">$ {{details.discount}}</td>-->
    <!--    <td class="p-2 text-sm text-gray-500">65-3456</td>-->
    <td class="p-2 text-sm text-gray-500">{{numberFormat(details.amount, '0,0')}}</td>
    <td class="p-2 text-sm text-gray-500">{{details.ordered_at | moment("from", "now")}}</td>
  </tr>
</template>

<script>
export default {
  name: 'table_data',
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  methods: {
    status(type) {
      let styleClass = '';
      switch (type.toLowerCase()) {
        case 'pending':
          styleClass = 'text-orange-300';
          break;
        case 'completed':
          styleClass = 'text-green-300';
          break;
        default:
          styleClass = 'text-red-300';
          break;
      }

      return styleClass;
    },
  },
};
</script>

<style scoped lang="scss">
tr:hover {
  td {
    color: white;
  }
}
</style>
